import { forwardRef } from "react";
import { cn } from "@/lib/utils";

interface PercentInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const PercentInput = forwardRef<HTMLInputElement, PercentInputProps>(
  ({ className, error, ...props }, ref) => {
    return (
      <div className="relative">
        <input
          ref={ref}
          type="number"
          step="1"
          min="0"
          max="100"
          className={cn(
            "flex h-9 w-full rounded-md border border-input bg-background pl-3 pr-9 py-1 text-sm shadow-sm transition-colors",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-destructive focus-visible:ring-destructive/50",
            className,
          )}
          {...props}
        />
        <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground select-none">
          %
        </span>
      </div>
    );
  },
);
PercentInput.displayName = "PercentInput";
